
<template>
  <div id="footer">
      <footer class="footer">
      <div class="float-right footer-rand-rechts">
          <span class="text-muted">
            <a v-bind:href="server_base_url()">{{ server_base_url() }}</a> 
            - <a v-bind:href="impressum_url()">Impressum</a>
            - <a href="/frontend/#/login">Login</a>
          </span>
      </div>
    </footer>
  </div>
</template>

<script>
// Mixin fuer diese Komponente importieren
import commonvars from './mixins/commonvars.js';

export default {
  mixins: [
    commonvars
  ]
}
</script>

<style scoped>
a {
  text-decoration: underline;
}

.footer-rand-rechts {
  margin-right: 40px;
}
</style>
